// File: src/components/MobilePreview.jsx
import React from "react";

const MobilePreview = () => {
  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      {/* Mobile Frame */}
      <div className="bg-white shadow-xl rounded-[40px] overflow-hidden border-4 border-black" style={{ width: "375px", height: "667px" }}>
        {/* Header */}
        <div className="bg-blue-600 text-white text-center py-3 text-lg font-semibold">
          Indresh Tiwari
        </div>

        {/* Content */}
        <div className="p-4 text-sm overflow-y-auto h-[calc(100%-48px)]">
          <h2 className="text-lg font-bold mb-2">Business Info</h2>
          <p><strong>Name:</strong> Indresh Tiwari</p>
          <p><strong>Address:</strong> Office No-306, 3rd floor, RG Trade Tower Netaji Subhash Place, New Delhi 110034</p>
          <p><strong>Director:</strong> Indresh Tiwari</p>
          <p><strong>Phone:</strong> <a href="tel:8383061417" className="text-blue-600">83830 61417</a></p>

          <h2 className="text-lg font-bold mt-4 mb-2">Google Map</h2>
          <div className="w-full h-48">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1749.9621899735553!2d77.14889163883838!3d28.69190859678087!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d039fbedc73e1%3A0xe924471237980ae7!2sHighxbrand!5e0!3m2!1sen!2sin!4v1758002882914!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Google Map"
            ></iframe>
          </div>

          <h2 className="text-lg font-bold mt-4 mb-2">Hours of Operation</h2>
          <p>Monday - Saturday: 9:30 AM – 6:30 PM</p>
          <p>Sunday: Closed</p>
        </div>
      </div>
    </div>
  );
};

export default MobilePreview;
